import * as app from './app'
import Amplify, { Auth } from 'aws-amplify'
import AuthService from 'services/auth'
import axios from 'axios'
import { createAction } from 'redux-act'
import { removeInvalidChar } from 'lib/Sanitaze'
import { push } from 'connected-react-router'

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEBCLIENT_ID,
    mandatorySignIn: false
  }
})

const menu = [{
  id: '1',
  title: 'Cobranças',
  icon: 'icmn icmn-barcode',
  url: '/'
}]


export const REDUCER = 'login'
const NS = `@@${REDUCER}/`

export const authError = createAction(`${NS}AUTH_ERROR`)
export const authRenew = createAction(`${NS}AUTH_RENEW`)
export const changePasswordRequired = createAction(`${NS}CHANGE_PASSWORD_REQUIRED`)
export const clearLogin = createAction(`${NS}CLEAR`)
export const codePasswordRequired = createAction(`${NS}CODE_PASSWORD_REQUIRED`)
export const isIncompleteCompanyData = createAction(`${NS}COMPANY_INCOMPLETE_DATA`)
export const loading = createAction(`${NS}LOADING`)
export const loginError = createAction(`${NS}LOGIN_ERROR`)
export const loginUser = createAction(`${NS}LOGIN_USER`)
export const newPasswordRequired = createAction(`${NS}NEW_PASSWORD_REQUIRED`)
export const newPasswordSuccess = createAction(`${NS}NEW_PASSWORD_SUCCESS`)
export const setAwsUser = createAction(`${NS}AWS_USER`)
export const setBankAccount = createAction(`${NS}SET_BANK_ACCOUNT`)
export const setCompany = createAction(`${NS}SET_COMPANY`)
export const setEmailUser = createAction(`${NS}SET_EMAIL_USER`)
export const setPermissions = createAction(`${NS}SET_PERMISSIONS`)
export const setMenu = createAction(`${NS}SET_MENU`)
export const setLoginCpf = createAction(`${NS}SET_LOGIN_CPF`)

export const checkAuth = () => {
  return (dispatch, getState) => {
    return Auth
      .currentSession()
      .then((session) => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${session.accessToken.jwtToken}`
        window.localStorage.setItem('login.username', session.idToken.payload['cognito:username'])
        window.localStorage.setItem('login.email', session.idToken.payload['email'])
        dispatch(authRenew(session))
      })
      .then(() => {
        const state = getState()
        const re = new RegExp('/#/(login|cadastro)$')

        if (state.login.previousLocation && !re.test(state.login.previousLocation)) {
          window.location = state.login.previousLocation
        }
      })
      .catch((err) => {
        dispatch(authError(err))
        dispatch(push('/login'))
      })
  }
}

export const login = (cnpjCpf, password) => async (dispatch, getState) => {
  try {
    dispatch(loading(true))

    dispatch(app.addSubmitForm(REDUCER))

    const state = getState()
    let cleanCnpjCpf = cnpjCpf.replace(/[^\d]+/g, '')
    const user = await Auth.signIn(cleanCnpjCpf, password)

    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
      dispatch(setStatePassword(false, true, false))
      dispatch(setLoginCpf(cnpjCpf))
      dispatch(setAwsUser(user))
      dispatch(app.deleteSubmitForm(REDUCER))
      dispatch(loginError(null))
      dispatch(loading(false))
      dispatch(push('/primeiro-login'))
      return Promise.resolve()
    }

    const session = await Auth.currentSession()

    dispatch(authRenew(session))
    axios.defaults.headers.common['Authorization'] = `Bearer ${session.accessToken.jwtToken}`
    dispatch(app.deleteSubmitForm(REDUCER))
    if (state.app.previousLocation) {
      dispatch(push(state.app.previousLocation))
      return true
    }
  
    dispatch(setMenu(menu))
    window.localStorage.setItem('login.menu', JSON.stringify(menu))
    dispatch(loading(false))
    dispatch(setStatePassword(false, false, false))
    dispatch(push('/'))
    return true
  } catch (err) {
    console.error(err)
    dispatch(loading(false))

    if (err.code === 'NotAuthorizedException') {
      dispatch(loginError({
        code: 'NotAuthorizedException'
      }))
    } else {
      dispatch(loginError({
        code: 'UserNotFoundException'
      }))
    }
    dispatch(app.deleteSubmitForm(REDUCER))
  }
}

export const firstLogin = (password) => async (dispatch, getState) => {
  try {
    dispatch(loading(true))

    dispatch(app.addSubmitForm(REDUCER))

    const state = getState()
    await Auth.completeNewPassword(state.login.user, password)

    dispatch(app.deleteSubmitForm(REDUCER))
    dispatch(loginError(null))
    dispatch(setStatePassword(false, false, true))
    dispatch(setAwsUser(null))
    dispatch(app.logout())
    dispatch(loading(false))
    dispatch(push('/login'))
    return Promise.resolve()
  } catch (err) {
    console.error(err)
    dispatch(loading(false))

    if (err.code === 'InvalidPasswordException') {
      dispatch(loginError({
        code: 'InvalidPasswordException'
      }))
    } else {
      dispatch(loginError({
        code: 'UserNotFoundException'
      }))
    }
    dispatch(app.deleteSubmitForm(REDUCER))
  }
}

export const requestNewPassword = async (dispatch, value) => {
  try {
    dispatch(loading(true))

    const response = await AuthService.requestPasswordCode({ email: value.cnpj })

    if (response.status === 200) {
      dispatch(setEmailUser(value.cnpj))
      dispatch(setStatePassword(true, false, false))
      dispatch(setAwsUser(null))
      dispatch(loginError({ code: 'PasswordResetRequiredException' }))
      dispatch(app.deleteSubmitForm(REDUCER))
      dispatch(loading(false))
      dispatch(push('/alterar-senha'))
      return Promise.resolve()
    }
  } catch (err) {
    dispatch(loading(false))

    if (err.response && err.response.data.code === 'LimitExceededException') {
      dispatch(loginError({ code: 'LimitExceededException' }))
    } else {
      dispatch(loginError({
        code: 'UserNotFoundException'
      }))
    }
    dispatch(app.deleteSubmitForm(REDUCER))
  }
}

export const changePasswordCode = (username, code, password) => async (dispatch, getState) => {
  try {
    dispatch(loading(true))

    await Auth.forgotPasswordSubmit(removeInvalidChar(username), code, password)

    dispatch(setAwsUser(null))
    dispatch(app.logout())
    dispatch(setStatePassword(false, false, true))
    dispatch(app.deleteSubmitForm(REDUCER))
    dispatch(loading(false))
    dispatch(push('/login'))

    return Promise.resolve()
  } catch (err) {
    console.error(err)
    dispatch(loading(false))

    if (err.code === 'InvalidPasswordException') {
      dispatch(loginError({
        code: 'InvalidPasswordException'
      }))
    } else if(err.code === 'CodeMismatchException'){
      dispatch(loginError({
        code: 'CodeMismatchException'
      }))
    }
    else if(err.code === 'InvalidParameterException'){
      dispatch(loginError({
        code: 'InvalidParameterException'
      }))
    }
    else if (err.code === 'LimitExceededException') {
      dispatch(loginError({
        code: 'LimitExceededException'
      }))
    }
    else {
      dispatch(loginError({
        code: 'UserNotFoundException'
      }))
    }
    
    dispatch(app.deleteSubmitForm(REDUCER))
  }
}

export const clearError = () => (dispatch) => {
  dispatch(loginError(null))
  dispatch(loading(false))
  dispatch(setEmailUser(null))
  dispatch(setStatePassword(false, false, false))
}

const setStatePassword = (setCodePasswordRequired, setNewPasswordRequired, setNewPasswordSuccess) => (dispatch) => {
  dispatch(codePasswordRequired(setCodePasswordRequired))
  dispatch(newPasswordRequired(setNewPasswordRequired))
  dispatch(newPasswordSuccess(setNewPasswordSuccess))
}

const defaultState = {
  company: parseInt(window.localStorage.getItem('login.company'), 10) || 0,
  error: null,
  jwt: window.localStorage.getItem('login.jwt') || null,
  loggedIn: window.localStorage.getItem('login.username') !== null,
  newPasswordRequired: false,
  previousLocation: null,
  role: null,
  user: null,
  username: window.localStorage.getItem('login.username') || null,
  bankAccount: window.localStorage.getItem('login.bankAccount') || null,
  incompleteCompanyData: Boolean(window.localStorage.getItem('login.incompleteCompanyData')),
  permissions: JSON.parse(window.localStorage.getItem('login.permissions')) || [],
  menu: JSON.parse(window.localStorage.getItem('login.menu')) || [],
  cpf: window.localStorage.getItem('login.cpf') || null
}

const reducer = (state, action) => {
  if (state === undefined) {
    return defaultState
  }

  switch (action.type) {
    case loginUser.toString():
    case setAwsUser.toString():
      return {
        ...state,
        user: action.payload
      }

    case newPasswordRequired.toString():
      return {
        ...state,
        newPasswordRequired: action.payload
      }

    case codePasswordRequired.toString():
      return {
        ...state,
        codePasswordRequired: action.payload
      }

    case newPasswordSuccess.toString():
      return {
        ...state,
        newPasswordSuccess: action.payload
      }

    case loading.toString():
      return {
        ...state,
        loading: action.payload
      }

    case setEmailUser.toString():
      return {
        ...state,
        setEmailUser: action.payload
      }

    case loginError.toString():
      return {
        ...state,
        error: action.payload
      }

    case setCompany.toString():
      return {
        ...state,
        company: parseInt(action.payload, 10)
      }

    case setBankAccount.toString():
      return {
        ...state,
        bankAccount: action.payload
      }

    case authRenew.toString():
      return {
        ...state,
        loggedIn: true,
        jwt: action.payload.accessToken.jwtToken,
        username: action.payload.idToken.payload['cognito:username']
      }

    case isIncompleteCompanyData.toString():
      return {
        ...state,
        incompleteCompanyData: action.payload
      }

    case setPermissions.toString():
      return {
        ...state,
        permissions: action.payload
      }

    case setMenu.toString():
      return {
        ...state,
        menu: action.payload
      }

    case clearLogin.toString():
      return defaultState

    default:
      return state
  }
}

export default reducer